import { inject, Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular/standalone';
import { TranslateService } from '@ngx-translate/core';
import { Fragment, updateAllInsert } from 'operationlib';

@Injectable({
  providedIn: 'root',
})
export class OperationService {
  alertCtrl = inject(AlertController);
  private translate = inject(TranslateService);
  compileOperationInsert(
    fragments: Fragment[],
    casestatus: 'creation' | 'execution' = 'execution'
  ) {
    return updateAllInsert(fragments, casestatus, (fragment) => {
      return this.alertCtrl
        .create({
          header: fragment.name?.split('_').join(' '),
          subHeader: this.translate.instant('common.insertValue'),
          cssClass: 'backdrop-opacity',
          backdropDismiss: false,
          animated: false,
          inputs: [
            {
              type: 'number',
              name: 'value',
              placeholder: this.translate.instant('common.insertValuePlaceholder'),
            },
          ],
          buttons: [
            {
              text: this.translate.instant('common.confirm'),
            },
          ],
        })
        .then((alert) => {
          alert.present();
          return alert.onWillDismiss();
        })
        .then((data) => data.data?.values?.value)
        .catch((error) => {
          console.error(
            'Error on insert value in execution, on operation:',
            fragments,
            error
          );
          return Promise.resolve(0);
        })
        .then((val) => {
          return {
            name: fragment.name,
            type: 'value',
            value: val && val.length ? +val : 0,
          };
        });
    });
  }
}
